import React, { Component } from 'react'
import Styles from './style.module.less'
import { observer } from 'mobx-react'

import store from '../store'

@observer
export default class extends Component {
  componentDidMount() {
    store.getInfo('id=' + store.id)
  }

  componentWillUnmount() {
    store.reset()
  }

  render() {
    let {
      orderInfo: {
        hotel,
        full_name,
        orderStatus,
        orderNo,
        orderFrom,
        created_at,
        viewed_at,
        userName,
        userPhone,
        userNameTo,
        userPhoneTo,
        weddingArea,
        shopStatus,
        weddingTime,
        eat_time,
        tables,
        prices,
        remark,
        customer
      }
    } = store

    let fullName = '暂无'
    let viewedAt = '未查看'
    if (full_name && full_name.length > 0) {
      fullName = full_name.map(v => <p key={v.id}>{v.fullname}</p>)
    }
    if (viewed_at) {
      viewedAt = viewed_at
    }

    return (
      <div className={Styles.orderBase}>
        <div className={Styles.baseLay}>
          <h3>订单信息</h3>
          <dl>
            <dt>酒店</dt>
            <dd>{hotel || '暂无'}</dd>
            <dt>订单状态</dt>
            <dd>{orderStatus || '暂无'}</dd>
            <dt>订单号</dt>
            <dd>{orderNo || '暂无'}</dd>
            <dt>订单来源</dt>
            <dd>{orderFrom || '暂无'}</dd>
            <dt>推荐时间</dt>
            <dd>{created_at || '暂无'}</dd>
            <dt>查看时间</dt>
            <dd>{viewedAt || '暂无'} </dd>
            <dt>接单人</dt>
            <dd>{fullName || '暂无'}</dd>
            <dt>派单员</dt>
            <dd>{customer || '暂无'}</dd>
          </dl>
        </div>
        <div className={Styles.baseLay}>
          <h3>客户信息</h3>
          <dl>
            <dt>客户称呼</dt>
            <dd>{userName || '暂无'}</dd>
            <dt>客户电话</dt>
            <dd>{userPhone || '暂无'}</dd>
            <dt>备用联系人</dt>
            <dd>{userNameTo || '暂无'}</dd>
            <dt>联系电话</dt>
            <dd>{userPhoneTo || '暂无'}</dd>
            <dt>婚宴地区</dt>
            <dd>{weddingArea || '暂无'}</dd>
            <dt>是否到店</dt>
            <dd>{shopStatus || '暂无'}</dd>
          </dl>
        </div>
        <div className={Styles.baseLay}>
          <h3>客户需求</h3>
          <dl>
            <dt>婚期</dt>
            <dd>{weddingTime || '暂无'}</dd>
            <dt>市别</dt>
            <dd>{eat_time || '暂无'}</dd>
            <dt>婚宴桌数</dt>
            <dd>{tables || '暂无'}</dd>
            <dt>每桌预算</dt>
            <dd>{prices || '暂无'}</dd>
          </dl>
        </div>
        <div className={Styles.baseLay}>
          <h3>备注</h3>
          <dl>
            <dt>
              <p>{remark || '暂无'}</p>
            </dt>
          </dl>
        </div>
      </div>
    )
  }
}
